import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-device-new-peripheral-breadcrumb-card',
  templateUrl: './device-new-peripheral-breadcrumb-card.component.html',
  styleUrls: ['./device-new-peripheral-breadcrumb-card.component.scss']
})
export class DeviceNewPeripheralBreadcrumbCardComponent implements OnInit {

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() { }

  public gotoDeviceDetail() {
    const internalId = this.activatedRoute.snapshot.params['deviceid'];
    this.router.navigate(['/device/' + internalId]);
  }
}
